<template>
  <div class="model-management anim-fade-in-up">
    <!-- 操作栏 -->
    <div class="content-card filter-bar">
      <div class="filter-left">
        <el-input v-model="searchKeyword" placeholder="请输入模型名称查询" size="small" style="width: 200px;" clearable @keyup.enter.native="fetchList" />
        <el-button size="small" @click="fetchList">查询</el-button>
        <el-button size="small" @click="searchKeyword='';fetchList();">重置</el-button>
      </div>
      <div class="filter-right">
        <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog">上传模型</el-button>
      </div>
    </div>

    <!-- 数据表 -->
    <div class="content-card" style="padding: 4px;">
      <el-table :data="filteredList" border stripe v-loading="loading" size="small" style="width: 100%">
        <el-table-column prop="id" label="ID" min-width="50" align="center" />
        <el-table-column prop="modelName" label="模型名称" min-width="120" show-overflow-tooltip />
        <el-table-column prop="fileName" label="文件名" min-width="130" show-overflow-tooltip />
        <el-table-column label="文件大小" min-width="90" align="center">
          <template slot-scope="{row}">{{ formatFileSize(row.fileSize) }}</template>
        </el-table-column>
        <el-table-column label="类别名" min-width="140" show-overflow-tooltip>
          <template slot-scope="{row}">
            <el-tag v-for="(cn, idx) in parseClassNames(row.classNames)" :key="idx" size="mini" style="margin:1px 2px;">{{ cn }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="inputSize" label="输入尺寸" min-width="80" align="center" />
        <el-table-column label="默认" min-width="75" align="center">
          <template slot-scope="{row}">
            <el-tag
              :type="row.isActive ? 'warning' : 'info'"
              size="small"
              style="cursor: pointer;"
              @click="handleActivate(row)"
            >{{ row.isActive ? '当前' : '未激活' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="上传时间" min-width="140" show-overflow-tooltip>
          <template slot-scope="{row}">{{ row.uploadTime || '—' }}</template>
        </el-table-column>
        <el-table-column label="操作" min-width="100" align="center">
          <template slot-scope="{row}">
            <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="openEditDialog(row)" />
            <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- ==================== 上传对话框 ==================== -->
    <el-dialog :visible.sync="uploadDialogVisible" title="上传新模型" width="520px" append-to-body :close-on-click-modal="false">
      <el-form :model="uploadForm" :rules="uploadRules" ref="uploadFormRef" label-width="90px">
        <el-form-item label="模型名称" prop="modelName">
          <el-input v-model="uploadForm.modelName" placeholder="如：YOLOv8 颗粒检测 v2" maxlength="100" />
        </el-form-item>
        <el-form-item label="模型文件" prop="file">
          <el-upload
            ref="uploadRef"
            :auto-upload="false"
            :limit="1"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :file-list="uploadFileList"
            accept=".onnx"
            action=""
          >
            <el-button size="small" icon="el-icon-folder-opened">选择 ONNX 文件</el-button>
            <div slot="tip" class="el-upload__tip">仅支持 .onnx 格式，大小不超过 100MB</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="类别名称" prop="classNames">
          <el-input v-model="uploadForm.classNames" placeholder="如：particle（多个用逗号分隔）" maxlength="500" />
          <span class="form-hint">多个类别用英文逗号分隔，如：Platymonas,Chlorella</span>
        </el-form-item>
        <el-form-item label="输入尺寸">
          <el-input-number v-model="uploadForm.inputSize" :min="32" :max="2048" :step="32" controls-position="right" size="small" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="uploadForm.description" placeholder="模型版本、训练数据等补充信息（可选）" maxlength="200" />
        </el-form-item>
        <el-form-item label="默认模型">
          <el-switch v-model="uploadForm.setActive" active-color="#B8860B" />
          <span class="form-hint" style="margin-left:8px;">开启后设为当前默认模型</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpload" :loading="uploading">上传</el-button>
      </div>
    </el-dialog>

    <!-- ==================== 编辑对话框 ==================== -->
    <el-dialog :visible.sync="editDialogVisible" :title="'编辑模型 — ' + (editForm.modelName || '')" width="500px" append-to-body :close-on-click-modal="false">
      <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="90px">
        <el-form-item label="模型名称" prop="modelName">
          <el-input v-model="editForm.modelName" placeholder="模型名称" maxlength="100" />
        </el-form-item>
        <el-form-item label="类别名称" prop="classNames">
          <el-input v-model="editForm.classNames" placeholder="如：particle（多个用逗号分隔）" maxlength="500" />
          <span class="form-hint">多个类别用英文逗号分隔</span>
        </el-form-item>
        <el-form-item label="输入尺寸">
          <el-input-number v-model="editForm.inputSize" :min="32" :max="2048" :step="32" controls-position="right" size="small" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="editForm.description" placeholder="描述信息（可选）" maxlength="200" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit" :loading="editing">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<style scoped>
.page-title {
  font-family: var(--font-display);
  font-size: 1.5rem; font-weight: 500;
  color: var(--text-primary); margin: 0 0 20px; letter-spacing: 0.04em;
}

.filter-bar {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 18px !important; margin-bottom: 14px;
}
.filter-left { display: flex; align-items: center; gap: 8px; }
.filter-right { display: flex; align-items: center; gap: 8px; }

.content-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}

.form-hint {
  display: block; font-size: 0.72rem; color: var(--text-muted);
  margin-top: 3px; line-height: 1.4;
}
</style>

<script>
export default {
  data() {
    return {
      // 列表
      loading: false,
      modelList: [],
      searchKeyword: '',

      // 上传
      uploadDialogVisible: false,
      uploading: false,
      uploadFile: null,
      uploadFileList: [],
      uploadForm: { modelName: '', classNames: '', inputSize: 640, description: '', setActive: false },
      uploadRules: {
        modelName: [{ required: true, message: '请输入模型名称', trigger: 'blur' }],
        classNames: [{ required: true, message: '请输入类别名称', trigger: 'blur' }]
      },

      // 编辑
      editDialogVisible: false,
      editing: false,
      editForm: { id: null, modelName: '', classNames: '', inputSize: 640, description: '' },
      editRules: {
        modelName: [{ required: true, message: '请输入模型名称', trigger: 'blur' }],
        classNames: [{ required: true, message: '请输入类别名称', trigger: 'blur' }]
      }
    }
  },

  computed: {
    filteredList() {
      if (!this.searchKeyword) return this.modelList;
      const kw = this.searchKeyword.toLowerCase();
      return this.modelList.filter(m =>
        (m.modelName && m.modelName.toLowerCase().includes(kw)) ||
        (m.fileName && m.fileName.toLowerCase().includes(kw))
      );
    }
  },

  created() { this.fetchList(); },

  methods: {
    // ========== 列表 ==========
    async fetchList() {
      this.loading = true;
      try {
        const resp = await this.$axios.get('/api/models/list');
        if (resp.data.code === 0) {
          this.modelList = resp.data.data || [];
        }
      } catch (e) { console.error('获取模型列表失败:', e); }
      finally { this.loading = false; }
    },

    // ========== 上传 ==========
    openUploadDialog() {
      this.uploadForm = { modelName: '', classNames: '', inputSize: 640, description: '', setActive: false };
      this.uploadFile = null; this.uploadFileList = [];
      this.uploadDialogVisible = true;
      this.$nextTick(() => { if (this.$refs.uploadFormRef) this.$refs.uploadFormRef.clearValidate(); });
    },

    handleFileChange(file) {
      this.uploadFile = file.raw;
      this.uploadFileList = [file];
    },

    handleFileRemove() {
      this.uploadFile = null;
      this.uploadFileList = [];
    },

    async submitUpload() {
      const valid = await this.$refs.uploadFormRef.validate().catch(() => false);
      if (!valid) return;
      if (!this.uploadFile) { this.$message.warning('请选择 ONNX 模型文件'); return; }
      if (!this.uploadFile.name.toLowerCase().endsWith('.onnx')) { this.$message.error('仅支持 .onnx 格式文件'); return; }

      this.uploading = true;
      try {
        const formData = new FormData();
        formData.append('file', this.uploadFile);
        formData.append('modelName', this.uploadForm.modelName.trim());
        formData.append('classNames', this.uploadForm.classNames.trim());
        formData.append('inputSize', this.uploadForm.inputSize);
        formData.append('description', (this.uploadForm.description || '').trim());
        formData.append('setActive', this.uploadForm.setActive ? 'true' : 'false');

        const resp = await this.$axios.post('/api/models/upload', formData);
        if (resp.data.code === 0) {
          this.$message.success('模型上传成功');
          this.uploadDialogVisible = false;
          this.fetchList();
        } else {
          this.$message.error(resp.data.msg || '上传失败');
        }
      } catch (e) { this.$message.error('上传失败，请检查文件大小和网络连接'); }
      finally { this.uploading = false; }
    },

    // ========== 编辑 ==========
    openEditDialog(row) {
      this.editForm = {
        id: row.id,
        modelName: row.modelName || '',
        classNames: row.classNames || '',
        inputSize: row.inputSize || 640,
        description: row.description || ''
      };
      this.editDialogVisible = true;
      this.$nextTick(() => { if (this.$refs.editFormRef) this.$refs.editFormRef.clearValidate(); });
    },

    async submitEdit() {
      const valid = await this.$refs.editFormRef.validate().catch(() => false);
      if (!valid) return;
      this.editing = true;
      try {
        const resp = await this.$axios.put(`/api/models/${this.editForm.id}`, {
          modelName: this.editForm.modelName.trim(),
          classNames: this.editForm.classNames.trim(),
          inputSize: String(this.editForm.inputSize),
          description: (this.editForm.description || '').trim()
        });
        if (resp.data.code === 0) {
          this.$message.success('模型信息已更新');
          this.editDialogVisible = false;
          this.fetchList();
        } else {
          this.$message.error(resp.data.msg || '更新失败');
        }
      } catch (e) { this.$message.error('更新失败'); }
      finally { this.editing = false; }
    },

    // ========== 默认 ==========
    async handleActivate(row) {
      if (row.isActive) return;
      try {
        const resp = await this.$axios.put(`/api/models/${row.id}/activate`);
        if (resp.data.code === 0) {
          this.$message.success('已设为默认模型');
          this.fetchList();
        } else {
          this.$message.error(resp.data.msg || '操作失败');
        }
      } catch (e) { this.$message.error('操作失败'); }
    },

    // ========== 删除 ==========
    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除模型「${row.modelName}」？删除后模型文件将一并移除。`, '确认删除', {
          type: 'warning', confirmButtonText: '删除', cancelButtonText: '取消'
        });
      } catch (e) { if (e !== 'cancel') console.error(e); return; }

      try {
        const resp = await this.$axios.delete(`/api/models/${row.id}`);
        if (resp.data.code === 0) {
          this.$message.success('模型已删除');
          this.fetchList();
        } else {
          this.$message.error(resp.data.msg || '删除失败');
        }
      } catch (e) { this.$message.error('删除失败'); }
    },

    // ========== 工具 ==========
    parseClassNames(cn) {
      if (!cn) return [];
      try {
        const arr = JSON.parse(cn);
        return Array.isArray(arr) ? arr : [cn];
      } catch (e) { return cn.split(',').map(s => s.trim()).filter(Boolean); }
    },

    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '0 B';
      const units = ['B', 'KB', 'MB', 'GB'];
      let i = 0, val = bytes;
      while (val >= 1024 && i < units.length - 1) { val /= 1024; i++; }
      return val.toFixed(i === 0 ? 0 : 1) + ' ' + units[i];
    }
  }
}
</script>
